import React from 'react';

import { ServicePageContainer } from '../../../components';
import { services } from '../../../utils/constants';
import './HolidayLetCleaningPage.scss';

function HolidayLetCleaningPage() {
  return (
    <ServicePageContainer service={services[8]} />
  );
}

export default HolidayLetCleaningPage;